import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { UserInfo } from '../model/user-info';
import { SharedUtils } from './shared-utils';

@Injectable ({
    providedIn: 'root'
})

export class PublicGuard implements CanActivate {

    constructor(private readonly permissionService: PermissionService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        // console.log("AuthGuard - canActivate(): " + route.params);
        // console.log("AuthGuard - canActivate(): " + route.data);
        // console.log("AuthGuard - canActivate(): " + route.toString());
        // console.log("AuthGuard - canActivate(): " + route.fragment);
        // console.log("AuthGuard - canActivate(): " + route.outlet);
        // console.log("AuthGuard - canActivate(): " + route.pathFromRoot);
        let userAuthenticated = this.permissionService.isUserAuthenticated();
        // console.log("PublicGuard - canActivate() - User Authenticated? ", userAuthenticated);
        if (userAuthenticated) {
            const userInfo: UserInfo | undefined = this.permissionService.getClientUser();
            if( SharedUtils.inputValueIsPresent(userInfo?.citizenInfo?.id) && SharedUtils.inputValueIsPresent(userInfo?.activeLegalEntityInfo?.id) ) {
                this.router.navigate(["dossier/main"]);
            } else {
                this.router.navigate(["membership/profileAccount"]);
            }
            return !userAuthenticated
        } else {
            return !userAuthenticated;
        }
    }
}

/********************
export const authGuard: CanActivateFn = (route, state) => {
  return true;
};
********************** */
